import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import SignupPage from './components/SignupPage';
import SignInPage from './components/SignInPage';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import ActivationPage from './components/ActivationPage';
import ProtectedRoute from './components/ProtectedRoute';
import UserHomeLayout from './components/UserHome/UserHomeLayout';
import DashboardPage from './components/UserHome/DashboardPage';
import WorkspaceManagementPage from './components/UserHome/WorkspaceManagementPage';
import PackManagementPage from './components/UserHome/Admin/PackManagementPage';
import WorkspaceSecretsPage from './components/UserHome/Admin/WorkspaceSecretsPage';
import McpServersPage from './components/UserHome/Admin/McpServersPage';
import GraphsPage from './components/UserHome/GraphsPage';
import LookupPage from './components/UserHome/LookupPage';
import LookupUploadPage from './components/UserHome/LookupUploadPage';
import LookupCmsPackUploadPage from './components/UserHome/LookupCmsPackUploadPage';
import EDNLPage from './components/ednl/EDNLPage';
import EDNLDemoPage from './components/ednl/EDNLDemoPage';
import StarkBenchmarkPage from './components/StarkBenchmark/StarkBenchmarkPage';
import IntegrationsPage from './components/UserHome/IntegrationsPage';
import AccountManagementPage from './components/UserHome/AccountManagementPage';
import UserManagementPage from './components/UserHome/UserManagementPage';
import SettingsPage from './components/UserHome/SettingsPage';
import ProfilePage from './components/UserHome/ProfilePage';
import BuildGraphPage from './components/UserHome/BuildGraphPage';
import BuildGraphPlaceholderPage from './components/UserHome/BuildGraphPlaceholderPage';
import ExplainabilityPage from './components/UserHome/ExplainabilityPage';
import AuditPage from './components/UserHome/AuditPage';
import CopyToEnvironmentPage from './components/UserHome/CopyToEnvironmentPage';
import ChangeNodesEdgesPage from './components/UserHome/ChangeNodesEdgesPage';
import GraphStatsPage from './components/UserHome/GraphStatsPage';
import QueryExpansionPage from './components/UserHome/QueryExpansionPage';
import TestGraphPage from './components/UserHome/TestGraphPage';
import EmbedTestGraphPage from './components/UserHome/EmbedTestGraphPage';
import TestCasesPage from './components/UserHome/TestCasesPage';
import ReviewFeedbackPage from './components/UserHome/ReviewFeedbackPage';
import DocumentConverterPage from './components/UserHome/DocumentConverterPage';
import BulkBuildPage from './components/UserHome/BulkBuildPage';
import ProcessListPage from './components/process/ProcessListPage';
import ProcessBuilderPage from './components/process/ProcessBuilderPage';
import ProcessExecutionPage from './components/process/ProcessExecutionPage';
import ProcessABPage from './components/process/ab/ProcessABPage';
import ChatAssistantListPage from './components/process/chat/ChatAssistantListPage';
import ChatAssistantEditPage from './components/process/chat/ChatAssistantEditPage';
import ChatAssistantPublicPage from './components/UserHome/ChatAssistantPublicPage';
import GraphLinksPage from './components/graph-links/GraphLinksPage';
import PromptTemplatesPage from './pages/settings/prompt-templates/PromptTemplatesPage';
import PromptTemplateDetailPage from './pages/settings/prompt-templates/PromptTemplateDetailPage';
import LeadMagnetManagementPage from './pages/admin/LeadMagnetManagementPage';
import LeadManagementPage from './pages/admin/LeadManagementPage';
import BillingDashboardPage from './pages/admin/billing/BillingDashboardPage';
import InstallationDetailPage from './pages/admin/billing/InstallationDetailPage';
import OnboardCustomerPage from './pages/admin/billing/OnboardCustomerPage';
import PricingPlansPage from './pages/admin/billing/PricingPlansPage';
import InvoiceListPage from './pages/admin/billing/InvoiceListPage';
import InvoiceDetailPage from './pages/admin/billing/InvoiceDetailPage';
import PricingPage from './pages/pricing/PricingPage';
import CheckoutPage from './pages/pricing/CheckoutPage';
import SubscriptionPage from './pages/pricing/SubscriptionPage';
import DemoPage from './components/DemoPage/DemoPage';
import DemoLivePage from './components/DemoLivePage/DemoLivePage';
import RequestDemoPage from './components/RequestDemo/RequestDemoPage';
import DemoRequestListPage from './pages/admin/demo-requests/DemoRequestListPage';
import DemoRequestDetailPage from './pages/admin/demo-requests/DemoRequestDetailPage';
import DeploymentPage from './components/UserHome/DeploymentPage';
import MonitoringPage from './components/UserHome/MonitoringPage';
import LLMProvidersPage from './pages/settings/llm-providers/LLMProvidersPage';
import CodingLLMPage from './pages/settings/coding-llm/CodingLLMPage';
import TransferEnvironmentsPage from './pages/settings/transfer-environments/TransferEnvironmentsPage';
import CacheManagementPage from './pages/settings/cache-management/CacheManagementPage';
// New Landing Page versions
import HomePageV2 from './components/LandingPage/HomePageV2';
import HomePageV3 from './components/LandingPage/HomePageV3';
import HomePageV4 from './components/LandingPage/HomePageV4';
import HomePageV5 from './components/LandingPage/HomePageV5';
import HowItWorks from './components/LandingPage/HowItWorks';
import PlatformPage from './components/LandingPage/PlatformPage';
import UseCasesPage from './components/LandingPage/UseCasesPage';
import ConsultingPage from './components/LandingPage/ConsultingPage';
import AboutPage from './components/LandingPage/AboutPage';
import TeamPage from './components/LandingPage/TeamPage';
import CareersPage from './components/LandingPage/CareersPage';
import ContactPage from './components/LandingPage/ContactPage';
import PrivacyPolicyPage from './components/LandingPage/PrivacyPolicyPage';
import TermsOfServicePage from './components/LandingPage/TermsOfServicePage';
import SecurityPage from './components/LandingPage/SecurityPage';
import LeadMagnetLandingPage from './components/LandingPage/LeadMagnetLandingPage';
import GoogleAdsTag from './components/analytics/GoogleAdsTag';
import CDIDemoPage from './components/HealthDemo/CDIDemoPage';

function App() {
  return (
    <Router>
      <GoogleAdsTag />
      <Routes>
        {/* Landing Page versions */}
        <Route path="/" element={<HomePageV5 />} />
        <Route path="/home-v2" element={<HomePageV2 />} />
        <Route path="/home-v3" element={<HomePageV3 />} />
        <Route path="/home-v4" element={<HomePageV4 />} />
        <Route path="/home-v5" element={<HomePageV5 />} />
        <Route path="/landing" element={<LandingPage />} />
        {/* Marketing pages */}
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/platform" element={<PlatformPage />} />
        <Route path="/use-cases" element={<UseCasesPage />} />
        <Route path="/consulting" element={<ConsultingPage />} />
        {/* Company pages */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />
        {/* Legal pages */}
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/security" element={<SecurityPage />} />
        {/* Auth pages */}
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login" element={<SignInPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/activate" element={<ActivationPage />} />
        <Route path="/request-demo" element={<RequestDemoPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/demo-live" element={<DemoLivePage />} />
        <Route path="/lm/:slug" element={<LeadMagnetLandingPage />} />
        {/* Hidden admin routes — not in any navigation */}
        <Route path="/system/demo-requests" element={<ProtectedRoute><DemoRequestListPage /></ProtectedRoute>} />
        <Route path="/system/demo-requests/:id" element={<ProtectedRoute><DemoRequestDetailPage /></ProtectedRoute>} />
        <Route path="/cdi-demo" element={<ProtectedRoute><CDIDemoPage /></ProtectedRoute>} />

        {/* Public embed: partner subdomains (dm.cerebralmachines.ai etc.)
            iframe this URL with ?embed_token=... so users get the Test
            Graph chat without ever seeing CM brand chrome or a login. */}
        <Route path="/embed/test-graph/:graphId" element={<EmbedTestGraphPage />} />

        {/* Public chat assistant: external apps embed this URL. Config and
            billing are locked server-side; no login or CM chrome. */}
        <Route path="/chatassist/:uuid" element={<ChatAssistantPublicPage />} />
        
        {/* Protected UserHome routes with nested routing */}
        <Route
          path="/user-home"
          element={
            <ProtectedRoute>
              <UserHomeLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="workspaces" element={<WorkspaceManagementPage />} />
          <Route path="admin/packs" element={<PackManagementPage />} />
          <Route path="admin/secrets" element={<WorkspaceSecretsPage />} />
          <Route path="admin/mcp-servers" element={<McpServersPage />} />
          <Route path="graphs" element={<GraphsPage />} />
          <Route path="graphs/bulk-build" element={<BulkBuildPage />} />
          <Route path="lookup" element={<LookupPage />} />
          <Route path="lookup/upload" element={<LookupUploadPage />} />
          <Route path="lookup/upload-cms-pack" element={<LookupCmsPackUploadPage />} />
          <Route path="graphs/build/:graphId" element={<BuildGraphPage />} />
          {/* Build & Tune Routes */}
          <Route path="graphs/build/:graphId/build-tune/document-converter" element={<DocumentConverterPage />} />
          <Route path="graphs/build/:graphId/build-tune/expand-graph" element={<BuildGraphPlaceholderPage />} />
          <Route path="graphs/build/:graphId/build-tune/change-nodes-edges" element={<ChangeNodesEdgesPage />} />
          <Route path="graphs/build/:graphId/build-tune/graph-stats" element={<GraphStatsPage />} />
          <Route path="graphs/build/:graphId/build-tune/query-expansion" element={<QueryExpansionPage />} />
          <Route path="graphs/build/:graphId/build-tune/auto-tune-graph" element={<BuildGraphPlaceholderPage />} />
          <Route path="graphs/build/:graphId/build-tune/explainability" element={<ExplainabilityPage />} />
          <Route path="graphs/build/:graphId/build-tune/prompt-library" element={<BuildGraphPlaceholderPage />} />
          <Route path="graphs/build/:graphId/build-tune/graph-prompts" element={<BuildGraphPlaceholderPage />} />
          {/* Train & Test Routes */}
          <Route path="graphs/build/:graphId/train-test/review-feedback" element={<ReviewFeedbackPage />} />
          {/* Legacy alias: old bookmarks to feedback-training resolve to the renamed page. */}
          <Route path="graphs/build/:graphId/train-test/feedback-training" element={<ReviewFeedbackPage />} />
          <Route path="graphs/build/:graphId/train-test/test-graph" element={<TestGraphPage />} />
          <Route path="graphs/build/:graphId/train-test/test-cases" element={<TestCasesPage />} />
          <Route path="graphs/build/:graphId/train-test/partial-import-export" element={<BuildGraphPlaceholderPage />} />
          {/* Connect & Stream Routes */}
          <Route path="graphs/build/:graphId/connect-stream/client-apps" element={<BuildGraphPlaceholderPage />} />
          <Route path="graphs/build/:graphId/connect-stream/endpoints" element={<BuildGraphPlaceholderPage />} />
          <Route path="graphs/build/:graphId/connect-stream/configure-event-streaming" element={<BuildGraphPlaceholderPage />} />
          <Route path="graphs/build/:graphId/connect-stream/graph-links" element={<GraphLinksPage />} />
          {/* Governance & Logs Routes */}
          <Route path="graphs/build/:graphId/governance-logs/audit-logs" element={<AuditPage />} />
          <Route path="graphs/build/:graphId/governance-logs/compare-versions" element={<BuildGraphPlaceholderPage />} />
          <Route path="graphs/build/:graphId/governance-logs/compliance" element={<BuildGraphPlaceholderPage />} />
          <Route path="graphs/build/:graphId/governance-logs/dictionary" element={<BuildGraphPlaceholderPage />} />
          {/* Deploy & Versions Routes */}
          <Route path="graphs/build/:graphId/deploy-versions/create-version" element={<BuildGraphPlaceholderPage />} />
          <Route path="graphs/build/:graphId/deploy-versions/deploy" element={<BuildGraphPlaceholderPage />} />
          <Route path="graphs/build/:graphId/deploy-versions/copy-to-environment" element={<CopyToEnvironmentPage />} />
          {/* Process Builder Routes (graph-scoped, kept for backward compat) */}
          <Route path="graphs/build/:graphId/processes" element={<ProcessListPage />} />
          <Route path="graphs/build/:graphId/processes/new" element={<ProcessBuilderPage />} />
          <Route path="graphs/build/:graphId/processes/:processId" element={<ProcessBuilderPage />} />
          <Route path="graphs/build/:graphId/processes/:processId/run" element={<ProcessExecutionPage />} />
          <Route path="graphs/build/:graphId/processes/:processId/ab" element={<ProcessABPage />} />
          {/* Global Process Maps Routes */}
          <Route path="process-maps" element={<ProcessListPage />} />
          <Route path="process-maps/new" element={<ProcessBuilderPage />} />
          <Route path="process-maps/:processId" element={<ProcessBuilderPage />} />
          <Route path="process-maps/:processId/run" element={<ProcessExecutionPage />} />
          <Route path="process-maps/:processId/ab" element={<ProcessABPage />} />
          {/* Chat Assistant Routes */}
          <Route path="chat-assistant" element={<ChatAssistantListPage />} />
          <Route path="chat-assistant/:assistantId" element={<ChatAssistantEditPage />} />
          <Route path="ednl" element={<EDNLPage />} />
          <Route path="ednl-demo" element={<EDNLDemoPage />} />
          <Route path="stark-benchmark" element={<StarkBenchmarkPage />} />
          <Route path="integrations" element={<IntegrationsPage />} />
          <Route path="account-management" element={<AccountManagementPage />} />
          <Route path="user-management" element={<UserManagementPage />} />
          <Route path="lead-magnet-management" element={<LeadMagnetManagementPage />} />
          <Route path="lead-management" element={<LeadManagementPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="monitoring" element={<MonitoringPage />} />
          <Route path="deployment" element={<DeploymentPage />} />
          <Route path="llm-providers" element={<LLMProvidersPage />} />
          <Route path="coding-llm" element={<CodingLLMPage />} />
          <Route path="transfer-environments" element={<TransferEnvironmentsPage />} />
          <Route path="prompt-templates" element={<PromptTemplatesPage />} />
          <Route path="prompt-templates/:templateId" element={<PromptTemplateDetailPage />} />
          <Route path="cache-management" element={<CacheManagementPage />} />
          <Route path="profile" element={<ProfilePage />} />
          {/* Self-service subscription & billing */}
          <Route path="pricing" element={<PricingPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="subscription" element={<SubscriptionPage />} />
          {/* Billing & Usage admin (CerebralAdmin only — gated inside each page) */}
          <Route path="admin/billing" element={<BillingDashboardPage />} />
          <Route path="admin/billing/onboard" element={<OnboardCustomerPage />} />
          <Route path="admin/billing/pricing-plans" element={<PricingPlansPage />} />
          <Route path="admin/billing/invoices" element={<InvoiceListPage />} />
          <Route path="admin/billing/invoices/:invoiceId" element={<InvoiceDetailPage />} />
          <Route path="admin/billing/installations/:installationId" element={<InstallationDetailPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
